import styled from 'styled-components';
import { Divider, Form, Input } from 'antd';

import SvgIcon from '../../components/svg-icon/';
import ButtonWithLoader from '../../components/ui-helpers/button-with-loader';
import { mediaSize } from '../../styles';

export const FormS = styled(Form)`
  display: flex;
  max-width: 536px;
  margin: 0 auto;
  width: 100%;
`;

export const FormItemS = styled(Form.Item)`
  width: 100%;
`;

export const AddEmailButton = styled(ButtonWithLoader)`
  margin-top: 0;
  background-color: ${props => props.theme.colors.tangerineSecond};
  color: ${props => props.theme.colors.white};
  width: 150px;
  height: 50px;
  border: none;
  border-radius: 0;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.tangerinePrimary};
  }
`;

export const InputS = styled(Input)`
  height: 50px;

  input {
    border-color: ${props => props.theme.colors.tangerineSecond};
    border-radius: 0;
    padding-left: 40px !important;
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
  }
`;

export const IconS = styled(SvgIcon)`
  margin-right: 11px;
`;

export const ListEmailsWrapper = styled.div`
  max-width: 536px;
  margin: 22px auto;
  width: 100%;
  height: 400px;
  overflow: auto;

  @media (max-width: ${mediaSize.phone}) {
    margin: 22px 8px;
  }
`;

export const EmailRowWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-flow: column wrap;
  border: 1px solid ${props => props.theme.colors.backgroundSilver};
  border-radius: 4px;
  min-height: 44px;
  padding: 0 15px 15px 15px;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const EmailRow = styled.div`
  padding-top: 15px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EmailValueWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  text-align: left;
`;

export const EmailValue = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.fontBlack};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: inline-block;
`;

export const RemoveEmailButton = styled.button`
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.backgroundLightDark : theme.colors.red};
  font-size: 13px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const DividerS = styled(Divider)`
  width: calc(100% + 48px);
  margin: 10px -24px 22px -24px;
`;

export const CountriesList = styled.div`
  span {
    color: ${({ theme }) => theme.colors.fontSilverDark};
  }
`;



// WEBPACK FOOTER //
// ./src/modals/manage-emails-modal/styled-components.js